import "@fontsource/geist-sans/400.css";
import "@fontsource/geist-sans/500.css";
import "@fontsource/geist-sans/600.css";
import "@fontsource/geist-sans/700.css";
import "@fontsource-variable/inter";

import "@/styles/globals.css";

import { QueryClientProvider } from "@tanstack/react-query";
import { createRouter, RouterProvider } from "@tanstack/react-router";
import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { createQueryClient } from "@/lib/query-client";
import { canAnimateSearchTransition, optimizeSearchTransition } from "@/lib/search-transition";
import { routeTree } from "./routeTree.gen";

const queryClient = createQueryClient();

const router = createRouter({
  routeTree,
  context: { queryClient },
  defaultPreloadStaleTime: 0,
});

router.subscribe("onBeforeNavigate", ({ fromLocation, toLocation }) => {
  router.update({
    context: router.options.context,
    defaultViewTransition:
      fromLocation?.pathname === "/search" &&
      toLocation.pathname === "/" &&
      canAnimateSearchTransition(),
  });
});

router.subscribe("onRendered", ({ fromLocation, toLocation }) => {
  if (
    (fromLocation?.pathname === "/" && toLocation.pathname === "/search") ||
    (fromLocation?.pathname === "/search" && toLocation.pathname === "/")
  ) {
    optimizeSearchTransition();
  }
});

declare module "@tanstack/react-router" {
  interface Register {
    router: typeof router;
  }
}

const rootElement = document.getElementById("root");
if (rootElement) {
  createRoot(rootElement).render(
    <StrictMode>
      <QueryClientProvider client={queryClient}>
        <RouterProvider router={router} />
      </QueryClientProvider>
    </StrictMode>,
  );
}
